export async function readControlCenterResponse(response) {
  try {
    return await response.json();
  } catch {
    throw new Error(response.status === 404
      ? 'Backend service endpoint was not found. Deploy the updated admin backend and check the frontend API URL.'
      : `The admin backend returned an unreadable response${response.status ? ` (HTTP ${response.status})` : ''}. Check the backend deployment and connection.`);
  }
}
